import { APPROVED_DEV_STATUS_ID, DRUG_DEV_STATUS_IDS } from '@patsnap/synapse_common_config'
import '@pharmsnap/shared/assets/icon-svg/stop.svg'
import { EMPTY_PLACEHOLDER } from '@pharmsnap/shared/constants'
import { IBaseDevStatusCountryInfo, IBaseDevStatusInfo } from '@pharmsnap/shared/types'
import { computed, defineComponent, PropType, toRefs } from '@vue/composition-api'
import { GCountryFlag } from '../../ui/GCountryFlag/GCountryFlag'
import { GLimited } from '../../ui/GLimited/GLimited'
import { GTooltip } from '../../ui/GTooltip/GTooltip'
import { BPipelineBar, checkOnlyHaveUnknownStatus, phase1Status, unknownStatus } from '../BPipelineBar/BPipelineBar'
import { BDevStatusPopperCard } from '../card/BDevStatusCard/BDevStatusPopperCard'
import $classes from './BDevStatusPipeline.module.scss'
import cn from './locales/cn.json'
import en from './locales/en.json'

export const BDevStatusPipeline = defineComponent({
  name: 'BDevStatusPipeline',
  i18n: {
    messages: { cn, en },
  },
  props: {
    items: {
      type: Array as PropType<IBaseDevStatusInfo[]>,
      default: () => [],
    },
  },
  setup(props) {
    const { items } = toRefs(props)
    const highestDevStatus = computed(() => items.value[0])
    const hasOnlyUnknownPhase = computed(() => checkOnlyHaveUnknownStatus(items.value))
    return {
      highestDevStatus,
      hasOnlyUnknownPhase,
    }
  },
  methods: {
    renderPhaseContainer() {
      return <div class={$classes.pipelinePhaseContainer}>{DRUG_DEV_STATUS_IDS.map((item) => this.renderPhaseItem(item))}</div>
    },
    renderArrowLineContainer() {
      return <BPipelineBar devStatusId={this.highestDevStatus.dev_status_id} unknownPhase={this.hasOnlyUnknownPhase}></BPipelineBar>
    },
    renderPhaseCountry(countryInfo: IBaseDevStatusCountryInfo[], isApproved: boolean) {
      return (
        <GLimited
          mode="expand"
          limit={4}
          items={countryInfo}
          inline={true}
          scopedSlots={{
            default: (props: { item: IBaseDevStatusCountryInfo }) => {
              const { country_view, inactive } = props.item
              const name = country_view?.alpha_2_code || country_view?.display_name || ''
              const inactiveContent = inactive ? (
                <GTooltip theme="light" mode="icon" iconName="Stop" iconSize={20}>
                  <div slot="content">{this.$tc('common.pipelineStop')}</div>
                </GTooltip>
              ) : (
                <span class={$classes.pipelineCountryPlaceholder}></span>
              )

              return (
                <span class={$classes.pipelineCountryItem}>
                  <BDevStatusPopperCard data={props.item} isApproved={isApproved}>
                    <GCountryFlag
                      class={$classes.pipelineCountryItemFlag}
                      name={name}
                      nameCn={country_view?.display_name_cn}
                      showName={true}
                      showUnknownCountryFlag
                    ></GCountryFlag>
                  </BDevStatusPopperCard>
                  {inactiveContent}
                </span>
              )
            },
          }}
        ></GLimited>
      )
    },
    renderPhaseItem(id: string) {
      const found = this.items.find((i) => i.dev_status_id === id)
      if (!found) {
        // 如果当前是临床1期的单元格，
        if (id === phase1Status) {
          // 且有临床不明的研发状态,则在临床1期的单元格中显示临床不明的国家
          const unknown = this.items.find((i) => i.dev_status_id === unknownStatus)
          if (unknown) {
            return (
              <div class={$classes.pipelinePhaseItem}>
                {unknown ? this.renderPhaseCountry(unknown.country_info, unknown.dev_status_id === APPROVED_DEV_STATUS_ID) : null}
              </div>
            )
          }
        }
      }

      return (
        <div class={$classes.pipelinePhaseItem}>
          {found ? this.renderPhaseCountry(found.country_info, found.dev_status_id === APPROVED_DEV_STATUS_ID) : null}
        </div>
      )
    },
  },
  render() {
    if (this.items.length) {
      return (
        <div>
          {this.renderPhaseContainer()}
          {this.renderArrowLineContainer()}
        </div>
      )
    }
    return <span>{EMPTY_PLACEHOLDER}</span>
  },
})
